import { useCallback } from "react";

import { useClientReportingActions } from "store";
import { FetchClientReportingScopeAction } from "store/types";

export const useFetchClientReportingScopeAction = (): FetchClientReportingScopeAction => {
  const { fetchReportingScope } = useClientReportingActions();

  return useCallback<FetchClientReportingScopeAction>(
    (clientId) => fetchReportingScope(clientId),
    [fetchReportingScope]
  );
};

export const fetchClientReportingScopeAction = useFetchClientReportingScopeAction;

export type { ClientReportingScopeResponse, ClientReportingScopeError } from "store/types";
